// src/components/Spinner.js
import React from 'react';
import { PulseLoader } from 'react-spinners';

const Spinner = () => {
  return (
    <div className="flex justify-center items-center w-full h-full py-20">
      <PulseLoader 
        color="#FF0000" // El rojo de tu marca (marizan-red)
        loading={true}
        size={15}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default Spinner;